import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Button, Spinner, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Alert, Table,} from "reactstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_green.css"; // Flatpickr styles

const Users = () => {
  const [modal, setModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [editModal, setEditModal] = useState(false);
  // const [userToEdit, setUserToEdit] = useState(null);
  const [userData, setUserData] = useState(null);

  const navigate = useNavigate();

  const toggleModal = () => setModal(!modal);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  // const toggleEditModal = () => setEditModal(!editModal);

  const token = sessionStorage.getItem("authToken");
  // Fetch users from the API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        // const userInfo = JSON.parse(sessionStorage.getItem("authUser"));
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          if (response.status === 400) {
            sessionStorage.clear();
            navigate("/login"); // Or use navigate if inside a component
          } 
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        // Sort users by creation date in descending order (newest first)
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        
        // Avoid updating files for now. So, remove files from the data object.
        const filteredData = data.map(({ user_document, ...rest }) => rest);
        setUsers(filteredData);
      } catch (error) {
        console.error("Error fetching users:", error);
        setError("Error fetching users: " + error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);
  
  // Update the user data
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("authUser"));
    setUserData(user);
  }, []);
  // console.log({userData})

  // Redirect to the view page
  const confirmView = (addendumId) => {
    // toggleModal();
    navigate(`/view-user/${addendumId}`);
  };

  // Confirm edit - Takes a single user data and sets it to the user to be edited
  // const confirmEdit = (user) => {
  //   // const {title, refer}
  //   setUserToEdit({ ...user });
  //   toggleEditModal();
  // };

  // Handle user update
  // const handleEdit = async () => {
  //   try {
  //     // Create FormData object
  //     const formData = new FormData();
  //     Object.keys(userToEdit).forEach((key) => {
  //       if (userToEdit[key] !== null && userToEdit[key] !== undefined) {
  //         if (key === "file" && userToEdit[key]) {
  //           formData.append(key, userToEdit[key]); // Append file field
  //         } else {
  //           formData.append(key, userToEdit[key]); // Append other fields
  //         }
  //       }
  //     });
  
  //     // Send PATCH request with FormData
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/api/user/${userToEdit._id}`,
  //       {
  //         method: "PATCH",
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           "Authorization": `Bearer ${token}`,
  //         },
  //         body: formData,
  //       }
  //     );
  
  //     if (!response.ok) {
  //       const responseError = await response.json();
  //       setError(responseError.err);
  //     }
  
  //     const updatedUser = await response.json();
  //     // console.log({updatedUser})
  //     setUsers((prevUsers) =>
  //       prevUsers.map((user) =>
  //         user._id === updatedUser._id ? updatedUser : user
  //       )
  //     );
  
  //     setSuccess("User updated successfully!");
  //     toggleEditModal();
  //   } catch (error) {
  //     console.error("Error updating user:", error);
  //     setError("Error: " + error.message)
  //   }
  // };

  // // Handle edit form input change
  // const handleEditChange = (e) => {
  //   const { name, value } = e.target;
  //   setUserToEdit({ ...userToEdit, [name]: value });
  // };

  // Confirm deletion
  const confirmDelete = (userId) => {
    setUserToDelete({ _id: userId });
    toggleDeleteModal();
  };

  // Handle user deletion
  const handleDelete = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/user/${userToDelete._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 400) {
          sessionStorage.clear();
          navigate("/login"); // Or use navigate if inside a component
        } 
        throw new Error("Network response was not ok");
      }
      setSuccess("User deleted successfully!");
      setUsers((prevUsers) =>
        prevUsers.filter((user) => user._id !== userToDelete._id)
      );
      toggleDeleteModal();
    } catch (error) {
      console.error("Error deleting user:", error);
      setError("Error: " + error.message);
    }
  };

  // Handle search input change
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter users based on search term and maintain the sorted order
  const filteredUsers = users
  .filter((user) =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => new Date(b.date_created) - new Date(a.date_created)); // Re-sort after filtering

  // Paginate users
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(
  indexOfFirstUser,
  indexOfLastUser
  );

  // Paginate function
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      {/* Manage Users Header */}
      <Card>
        <CardHeader>Manage Users</CardHeader>
        <CardBody>
          {/* Search Bar */}
          <Row>
            <Col md={6}>
              <Input
                type="text"
                placeholder="Search by username..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </Col>
            <Col md={4}></Col>
            <Col md={2} className="float-right">
            {userData && userData.role !== 'director' && (
              <Button color="primary" href="add-user"> 
                Add User
              </Button>
            )}
            </Col>
          </Row>

          {/* Alerts */}
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">{success}</Alert>}


          {/* Users Table */}
          {loading ? (
            <Spinner color="primary" />
          ) : (
            <Table striped>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user, index) => (
                    <tr key={user._id}>
                      <td>{indexOfFirstUser + index + 1}</td>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.phone}</td>
                      <td>{user.role}</td>
                      <td>
                        <Button
                          color="warning"
                          size="sm"
                          onClick={() => confirmView(user._id)}
                        >
                          More
                        </Button>{" "}
                        {/* <Button color="success" size="sm" onClick={() => confirmEdit(user)}>
                          Edit
                        </Button>{" "} */}
                        <Button color="danger" size="sm" onClick={() => confirmDelete(user._id)}>
                          Delete
                        </Button>                        
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      Sorry! No Results Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}

          {/* Pagination */}
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <Button
                color="secondary"
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </Button>
              {Array.from(
                { length: Math.ceil(filteredUsers.length / usersPerPage) },
                (_, i) => (
                  <Button
                    key={i + 1}
                    color={currentPage === i + 1 ? "primary" : "light"}
                    onClick={() => paginate(i + 1)}
                  >
                    {i + 1}
                  </Button>
                )
              )}
              <Button
                color="secondary"
                onClick={() =>
                  paginate(
                    Math.ceil(filteredUsers.length / usersPerPage)
                  )
                }
                disabled={
                  currentPage ===
                  Math.ceil(filteredUsers.length / usersPerPage)
                }
              >
                Next
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* Add User Modal */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add User</ModalHeader>
        <ModalBody>
          <Form>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">Save</Button>{" "}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
        <ModalHeader toggle={toggleDeleteModal}>Confirm Delete</ModalHeader>
        <ModalBody>Are you sure you want to delete this user?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDelete}>
            Yeah
          </Button>{" "}
          <Button color="secondary" onClick={toggleDeleteModal}>
            Nope
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit User Modal */}
      {/* <Modal isOpen={editModal} toggle={toggleEditModal}>
        <ModalHeader toggle={toggleEditModal}>Edit User</ModalHeader>
        <ModalBody>
          {userToEdit && (
            <Form>
              {Object.keys(userToEdit).map((key) => (
                <FormGroup key={key}>
                      <Label>{key.replace("_", " ")}</Label>
                      { 
                        <Input
                          type="text"
                          name={key}
                          value={userToEdit[key]}
                          onChange={handleEditChange}
                        />
                      }
                </FormGroup>
              ))}
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleEdit}>
            Save Changes
          </Button>{" "}
          <Button color="secondary" onClick={toggleEditModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}
    </div>
  );
};

export default Users;